@if (vm.isError) {
  <app-mmr-page-error />
} @else {
  <section class="back-link mb-24">
    <i class="fa-light fa-arrow-left mr-8"></i>

    <a [href]="vm.dashboardLink" class="button-text"> Back to dashboard </a>
  </section>

  <app-mmr-title-block />

  <app-support-needs-banner class="mt-24 md-mt-20" />

  @if (vm.showDirectReferralPanel) {
    <app-direct-referral class="mt-24 md-mt-20" />
  }

  @if (vm.showRepairPanel || vm.claimsInformationLoading) {
    <app-claim-details class="mt-24 md-mt-20" claimType="repair" />
  }

  @if (vm.showElectricalSafety) {
    <app-electrical-safety [loading]="vm.planDetailsLoading" class="mt-24 md-mt-20" />
  }

  @if (vm.showServicePanel) {
    <app-claim-details class="mt-24 md-mt-20" claimType="service" />
  }

  @if (vm.showHistoryPanel) {
    <app-history class="mt-24 md-mt-16" />
  }

  <app-smart-fix-hub [loading]="vm.planDetailsLoading" class="mt-24 md-mt-20" />

  <app-mmr-faqs
    class="mt-20 block"
    [categoryCode]="vm.goodsColour"
    [repairerName]="vm.repairerName | firstLetterCapitalise"
  />

  <section class="view-plan-details">
    <app-button
      dataLabel="view-plan-details"
      class="mt-48"
      [buttonOptions]="{
        variant: 'link',
        fill: false,
        isLink: true,
        url: vm.viewPlanDetailsUrl,
      }"
    >
      <span> View plan details </span>
      <i class="fa-light fa-arrow-right ml-4"></i>
    </app-button>
  </section>
}
